export default {
  messageType: {
    search: {
      messageTypeName: '消息类型',
      messageTypeNamePlaceholder: '请输入消息类型名称',
      messageTypePlaceholder: '请选择消息类型名称',
      status: '消息状态',
      statusPlaceholder: '请选择消息状态',
      sendTimeStart: '发送时间始',
      sendTimeStartPlaceholder: '请选择发送时间始',
      sendTimeEnd: '发送时间止',
      sendTimeEndPlaceholder: '请选择发送时间止',
    },
    table: {
      messageTypeName: '类型名称',
      messageTypeDesc: '消息类型描述',
      gmtCreate: '创建时间',
      title: '消息标题',
      content: '消息内容',
      approvalStatus: '审核状态',
      sendTime: '发送时间',
      state: '发送状态',
      readStatus: '阅读状态',
    },
    form: {
      messageAddTitle: '新增消息类型',
      messageEditTitle: '修改消息类型',
      messageTempAddTitle: '新增消息模板',
      messageTempEditTitle: '修改消息模板',
      messageTempDetailTitle: '消息模板详情',
      messageTaskDetailTitle: '消息任务详情',
      userMessageDetailTitle: '消息任务详情',
      channelsName: '发送渠道',
      sendMessageTitle: '发送新消息',
      messageTypeName: '类型名称',
      messageTypeNamePlaceholder: '请输入类型名称',
      messageTypeDesc: '类型描述',
      messageTypeDescPlaceholder: '请输入类型描述',
      type: '消息类型',
      typePlaceholder: '请选择消息类型',
      channel: '',
      channelPlaceholder: '请选择发送渠道',
      date: '发送时间',
      datePlaceholder: '请选择发送时间',
      person: '发送对象',
      personPlaceholder: '请选择发送对象',
      channel1: '短信',
      channel2: '站内信',
      channel3: 'APP推送',
      channel4: '邮件',
      messageTypeId: '消息类型',
      messageTypeIdPlaceholder: '请选择消息类型',
      title: '消息标题',
      titlePlaceholder: '请输入消息标题',
      content: '消息内容',
      contentPlaceholder: '请输入消息内容',
      redirectUrl: '关联URL',
      redirectUrlPlaceholder: '请输入关联URL',
      receiverNames: '发送对象',
    },
  },
};
